// Старая позиция баннера → место из словаря v2 (MOB-470). Старые события шлют
// позицию как раньше; новое значение — только в событиях v2.
import Logger from '@web/common/Logger'
import { PLACEMENTS, Placement } from '@web/services/Analytics/registry'

const PLATFORM_PREFIX = /^(desktop|tablet|mobile|app)_/

// Экраны из BannerMapper.Position (и mainPage спецблоков) → экран словаря.
const SCREEN: Record<string, string> = {
  mainPage: 'home',
  home: 'home',
  courses: 'courses',
  Catalog: 'courses',
  calendar: 'calendar',
  day: 'course_day',
  homeworks: 'homeworks',
  videoconsultations: 'videoconsultations',
  support: 'support',
  settings: 'settings',
  banners: 'banners'
}

function snake (value: string): string {
  return value.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()
}

function isPlacement (value: string): value is Placement {
  return (PLACEMENTS as readonly string[]).includes(value)
}

export function placementOf (oldPosition: string): { placement: Placement, position?: number } {
  const rest = oldPosition.replace(PLATFORM_PREFIX, '').replace(/_+$/, '')
  // Спецблоки главной: с префиксом mainPage_ (сам спецблок) или без
  // (AsBanner внутри спецблока получает только своё место).
  const homeSlot = rest.replace(/^mainPage_/, '')

  const underCategory = /^under_category_(\d+)$/.exec(homeSlot)
  if (underCategory) return { placement: 'home_under_category', position: Number(underCategory[1]) }
  if (homeSlot === 'top') return { placement: 'home_top' }
  if (homeSlot === 'underListOfCategories') return { placement: 'home_under_categories' }
  if (rest.endsWith('_newLevel')) return { placement: 'home_new_level' }

  const [screen, ...slot] = rest.split('_')
  // /banners — один экран-список баннеров: слот (catalog и т. п.) не различаем.
  if (screen === 'banners') return { placement: 'banners_list' }
  const candidate = `${SCREEN[screen] ?? snake(screen)}_${slot.length ? snake(slot.join('_')) : 'list'}`
  if (isPlacement(candidate)) return { placement: candidate }

  Logger.warn(`[Analytics v2] позиция баннера "${oldPosition}" не из словаря мест — placement=unknown`)
  return { placement: 'unknown' }
}
